import { isArray } from 'util';
import { Part } from '../part';

export class PartBuilder {
  static fromJson(json) {
    return (json)
      ? new Part(
        json.hash,
        json.name,
        json.slug,
        json.erpTask,
        json.erpTaskName
      )
      : null;
  }

  static fromList(list) {
    return (isArray(list)) ? list.map(PartBuilder.fromJson) : [];
  }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/builders/part.builder.ts